(() => {
  const selector = '.door-compatibility';

  const init = (section) => {
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const form = section.querySelector('form');
    const input = section.querySelector('input[type="file"]');
    const dropzone = section.querySelector('.door-compatibility__dropzone');
    const preview = section.querySelector('.door-compatibility__preview');
    const previewImage = section.querySelector('.door-compatibility__preview-image');
    const fileName = section.querySelector('.door-compatibility__file-name');
    const fileError = section.querySelector('[data-file-error]');
    const formContent = section.querySelector('.door-compatibility__form-content');
    const success = section.querySelector('.door-compatibility__success');
    const reviewButton = section.querySelector('[data-review]');
    const editButton = section.querySelector('[data-edit-resend]');
    const summary = section.querySelector('[data-summary]');
    const summaryImage = section.querySelector('[data-summary-image]');
    const summaryFile = section.querySelector('[data-summary-file]');
    const summaryName = section.querySelector('[data-summary-name]');
    const summaryPhone = section.querySelector('[data-summary-phone]');
    const summaryCity = section.querySelector('[data-summary-city]');
    const citySelector = section.querySelector('[data-city-selector]');
    const cityInput = section.querySelector('[data-city-input]');
    const cityToggle = section.querySelector('[data-city-toggle]');
    const cityMenu = section.querySelector('[data-city-menu]');
    const cityOptionsSource = section.querySelector('[data-city-options]');
    const productSelector = section.querySelector('[data-product-selector]');
    const productTrigger = section.querySelector('[data-product-trigger]');
    const productMenu = section.querySelector('[data-product-menu]');
    const productPlaceholder = section.querySelector('[data-product-placeholder]');
    const productSelection = section.querySelector('[data-product-selection]');
    const productError = section.querySelector('[data-product-field-error]');
    const summaryProductImage = section.querySelector('[data-summary-product-image]');
    const summaryProductTitle = section.querySelector('[data-summary-product-title]');
    const summaryProductPrice = section.querySelector('[data-summary-product-price]');
    const consentInput = section.querySelector('[data-consent-input]');
    const consentDateInput = section.querySelector('[data-consent-date]');
    const consentText = section.querySelector('[data-consent-text]');
    const legalConsentInputs = Array.from(section.querySelectorAll('[data-legal-consent]'));
    const submit = section.querySelector('[type="submit"]');
    const submitText = section.querySelector('[data-submit-text]');
    const status = section.querySelector('.door-compatibility__status');
    const defaultSubmitText = submitText.textContent;
    let objectUrl = '';
    let selectedFile = null;
    let selectedProduct = null;

    const syncConsent = (checked) => {
      if (consentInput) consentInput.checked = checked;
      legalConsentInputs.forEach((input) => { input.checked = checked; });
      if (checked) setError(section.querySelector('[data-error-for="consent"]'), '');
    };

    section.querySelectorAll('[data-legal-dialog]').forEach((dialog) => {
      dialog.querySelectorAll('[data-legal-close]').forEach((button) => {
        button.addEventListener('click', () => dialog.close());
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });

    if (consentInput) {
      consentInput.addEventListener('change', () => syncConsent(consentInput.checked));
    }

    legalConsentInputs.forEach((input) => {
      input.addEventListener('change', () => {
        syncConsent(input.checked);
        if (input.checked) input.closest('[data-legal-dialog]').close();
      });
    });

    if (consentText) {
      consentText.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', (event) => {
          const linkPath = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '');
          const dialog = Array.from(section.querySelectorAll('[data-legal-dialog]')).find((item) => {
            const dialogPath = new URL(item.dataset.legalUrl, window.location.origin).pathname.replace(/\/$/, '');
            return dialogPath === linkPath;
          });
          if (!dialog || typeof dialog.showModal !== 'function') return;
          event.preventDefault();
          syncConsent(Boolean(consentInput && consentInput.checked));
          const scrollArea = dialog.querySelector('[data-legal-scroll]');
          if (scrollArea) scrollArea.scrollTop = 0;
          dialog.showModal();
        });
      });
    }

    if (citySelector && cityInput && cityMenu && cityOptionsSource) {
      const cities = Array.from(cityOptionsSource.options, (option) => option.value);
      let activeIndex = -1;

      const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      const visibleOptions = () => Array.from(cityMenu.querySelectorAll('[data-city-option]'));

      const setActiveCity = (index) => {
        const options = visibleOptions();
        options.forEach((option) => option.classList.remove('is-active'));
        if (!options.length) {
          activeIndex = -1;
          cityInput.removeAttribute('aria-activedescendant');
          return;
        }
        activeIndex = Math.max(0, Math.min(index, options.length - 1));
        const active = options[activeIndex];
        active.classList.add('is-active');
        cityInput.setAttribute('aria-activedescendant', active.id);
        active.scrollIntoView({ block: 'nearest' });
      };

      const chooseCity = (city) => {
        cityInput.value = city;
        cityInput.dispatchEvent(new Event('change', { bubbles: true }));
        cityMenu.hidden = true;
        cityInput.setAttribute('aria-expanded', 'false');
        cityInput.removeAttribute('aria-activedescendant');
        activeIndex = -1;
        cityInput.focus();
      };

      const renderCities = (query = '') => {
        const search = normalize(query.trim());
        const matches = cities.filter((city) => !search || normalize(city).includes(search));
        cityMenu.replaceChildren(...matches.map((city, index) => {
          const option = document.createElement('button');
          option.type = 'button';
          option.id = `${cityMenu.id}-option-${index}`;
          option.className = 'door-compatibility__city-option';
          option.dataset.cityOption = '';
          option.setAttribute('role', 'option');
          option.textContent = city;
          option.addEventListener('mousedown', (event) => event.preventDefault());
          option.addEventListener('click', () => chooseCity(city));
          return option;
        }));
        activeIndex = -1;
      };

      const openCityMenu = () => {
        renderCities(cityInput.value);
        cityMenu.hidden = false;
        cityInput.setAttribute('aria-expanded', 'true');
      };

      const closeCityMenu = () => {
        cityMenu.hidden = true;
        cityInput.setAttribute('aria-expanded', 'false');
        cityInput.removeAttribute('aria-activedescendant');
        activeIndex = -1;
      };

      cityInput.addEventListener('focus', openCityMenu);
      cityInput.addEventListener('click', openCityMenu);
      cityInput.addEventListener('input', openCityMenu);
      cityToggle.addEventListener('click', () => {
        if (cityMenu.hidden) {
          cityInput.focus();
          openCityMenu();
        } else {
          closeCityMenu();
        }
      });
      cityInput.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (cityMenu.hidden) openCityMenu();
          setActiveCity(activeIndex + (event.key === 'ArrowDown' ? 1 : -1));
        } else if (event.key === 'Enter' && activeIndex >= 0) {
          event.preventDefault();
          chooseCity(visibleOptions()[activeIndex].textContent);
        } else if (event.key === 'Escape') {
          closeCityMenu();
        }
      });
      document.addEventListener('click', (event) => {
        if (!citySelector.contains(event.target)) closeCityMenu();
      });
    }

    const setError = (element, message) => {
      if (!element) return;
      element.textContent = message || '';
      element.hidden = !message;
    };

    const clearErrors = () => {
      setError(fileError, '');
      setError(productError, '');
      section.querySelectorAll('[data-error-for]').forEach((el) => setError(el, ''));
      setError(status, '');
    };

    const validFile = (file) => {
      if (!file) {
        setError(fileError, section.dataset.photoRequiredError);
        return false;
      }
      const extension = file.name.split('.').pop().toLowerCase();
      const allowedExtensions = ['jpg', 'jpeg', 'jpe', 'jfif', 'png', 'jp2', 'j2k'];
      if (!allowedExtensions.includes(extension)) {
        setError(fileError, section.dataset.fileTypeError);
        return false;
      }
      const limit = Number(section.dataset.maxFileSize || 10) * 1024 * 1024;
      if (file.size > limit) {
        setError(fileError, section.dataset.fileSizeError);
        return false;
      }
      setError(fileError, '');
      return true;
    };

    const showFile = (file) => {
      if (!validFile(file)) {
        input.value = '';
        selectedFile = null;
        return;
      }
      selectedFile = file;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = URL.createObjectURL(file);
      previewImage.src = objectUrl;
      previewImage.alt = file.name;
      fileName.textContent = file.name;
      dropzone.hidden = true;
      preview.hidden = false;
    };

    const resetFile = () => {
      input.value = '';
      selectedFile = null;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = '';
      previewImage.removeAttribute('src');
      fileName.textContent = '';
      preview.hidden = true;
      dropzone.hidden = false;
      setError(fileError, '');
    };

    const applySelectedProduct = (product) => {
      if (!productSelector || !product || !product.id || !product.title) return false;

      selectedProduct = {
        id: String(product.id),
        title: String(product.title),
        price: String(product.price || ''),
        url: String(product.url || ''),
        image: String(product.image || '')
      };

      form.querySelector('[data-product-name]').value = selectedProduct.title;
      form.querySelector('[data-product-price]').value = selectedProduct.price;
      form.querySelector('[data-product-url]').value = selectedProduct.url
        ? new URL(selectedProduct.url, window.location.origin).href
        : window.location.href;
      form.querySelector('[data-product-id]').value = selectedProduct.id;

      const selectedProductImage = section.querySelector('[data-selected-product-image]');
      selectedProductImage.src = selectedProduct.image;
      selectedProductImage.alt = selectedProduct.title;
      selectedProductImage.hidden = !selectedProduct.image;
      section.querySelector('[data-selected-product-title]').textContent = selectedProduct.title;
      section.querySelector('[data-selected-product-price]').textContent = selectedProduct.price;
      if (productPlaceholder) productPlaceholder.hidden = true;
      productSelection.hidden = false;
      setError(productError, '');

      if (summaryProductImage) {
        summaryProductImage.src = selectedProduct.image;
        summaryProductImage.alt = selectedProduct.title;
        summaryProductImage.hidden = !selectedProduct.image;
        summaryProductTitle.textContent = selectedProduct.title;
        summaryProductPrice.textContent = selectedProduct.price;
      }

      section.querySelectorAll('[data-select-product-option]').forEach((option) => {
        const isSelected = option.dataset.productId === selectedProduct.id;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-pressed', String(isSelected));
      });

      return true;
    };

    input.addEventListener('change', () => showFile(input.files[0]));

    ['dragenter', 'dragover'].forEach((eventName) => {
      dropzone.addEventListener(eventName, (event) => {
        event.preventDefault();
        dropzone.classList.add('is-dragging');
      });
    });

    ['dragleave', 'drop'].forEach((eventName) => {
      dropzone.addEventListener(eventName, (event) => {
        event.preventDefault();
        dropzone.classList.remove('is-dragging');
      });
    });

    dropzone.addEventListener('drop', (event) => {
      const file = event.dataTransfer && event.dataTransfer.files[0];
      if (!file) return;
      showFile(file);
    });

    section.querySelector('[data-replace]').addEventListener('click', () => input.click());
    section.querySelector('[data-remove]').addEventListener('click', resetFile);

    if (productSelector) {
      applySelectedProduct({
        id: productSelector.dataset.initialProductId,
        title: productSelector.dataset.initialProductTitle,
        price: productSelector.dataset.initialProductPrice,
        url: productSelector.dataset.initialProductUrl,
        image: productSelector.dataset.initialProductImage
      });

      const closeProductMenu = () => {
        productMenu.hidden = true;
        productTrigger.setAttribute('aria-expanded', 'false');
      };

      productTrigger.addEventListener('click', () => {
        const willOpen = productMenu.hidden;
        productMenu.hidden = !willOpen;
        productTrigger.setAttribute('aria-expanded', String(willOpen));
      });

      productSelector.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeProductMenu();
          productTrigger.focus();
        }
      });

      document.addEventListener('click', (event) => {
        if (!productSelector.contains(event.target)) closeProductMenu();
      });

      section.querySelectorAll('[data-select-product-option]').forEach((option) => {
        option.addEventListener('click', () => {
          if (!applySelectedProduct({
            id: option.dataset.productId,
            title: option.dataset.productTitle,
            price: option.dataset.productPrice,
            url: option.dataset.productUrl,
            image: option.dataset.productImage
          })) return;
          closeProductMenu();
          productTrigger.focus();
        });
      });

      section.querySelectorAll('[data-open-product]').forEach((button) => {
        button.addEventListener('click', () => {
          const dialog = document.getElementById(button.dataset.openProduct);
          closeProductMenu();
          if (dialog && typeof dialog.showModal === 'function') {
            const shell = dialog.querySelector('.door-compatibility__quick-view-shell');
            if (shell) shell.scrollTop = 0;
            dialog.showModal();
          }
        });
      });

      section.querySelectorAll('[data-product-dialog]').forEach((dialog) => {
        const mainImage = dialog.querySelector('.door-compatibility__quick-view-main-image');

        dialog.querySelector('[data-close-product]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });

        dialog.querySelectorAll('[data-product-thumbnail]').forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => {
            if (mainImage) {
              mainImage.removeAttribute('srcset');
              mainImage.src = thumbnail.dataset.productThumbnail;
            }
            dialog.querySelectorAll('[data-product-thumbnail]').forEach((item) => item.classList.remove('is-active'));
            thumbnail.classList.add('is-active');
          });
        });

        dialog.querySelector('[data-select-product]').addEventListener('click', () => {
          applySelectedProduct({
            id: dialog.dataset.productId,
            title: dialog.dataset.productTitle,
            price: dialog.dataset.productPrice,
            url: dialog.dataset.productUrl,
            image: dialog.dataset.productImage
          });

          dialog.close();
          productTrigger.focus();
        });

        document.addEventListener('variant:add', (event) => {
          if (event.detail && event.detail.formElement && dialog.contains(event.detail.formElement)) {
            dialog.close();
          }
        });
      });

      section.addEventListener('qeydo:compatibility-product', (event) => {
        if (!applySelectedProduct(event.detail)) return;
        closeProductMenu();
      });
    }

    reviewButton.addEventListener('click', () => {
      const willOpen = summary.hidden;
      summary.hidden = !willOpen;
      reviewButton.setAttribute('aria-expanded', String(willOpen));
      reviewButton.textContent = willOpen ? reviewButton.dataset.hideLabel : reviewButton.dataset.showLabel;
      if (willOpen) summary.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    editButton.addEventListener('click', () => {
      summary.hidden = true;
      reviewButton.setAttribute('aria-expanded', 'false');
      reviewButton.textContent = reviewButton.dataset.showLabel;
      success.hidden = true;
      formContent.hidden = false;
      form.elements.name.focus({ preventScroll: true });
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      clearErrors();

      const name = form.elements.name.value.trim();
      const phone = form.elements.phone.value.trim();
      const city = form.elements.city.value.trim();
      let valid = validFile(selectedFile);

      if (productSelector && !selectedProduct) {
        setError(productError, section.dataset.productError);
        valid = false;
      }

      if (!name) {
        setError(section.querySelector('[data-error-for="name"]'), section.dataset.nameError);
        valid = false;
      }

      const phoneDigits = phone.replace(/\D/g, '');
      if (!/^(?:0)?[5-7]\d{8}$/.test(phoneDigits)) {
        setError(section.querySelector('[data-error-for="phone"]'), section.dataset.phoneError);
        valid = false;
      }

      if (!city) {
        setError(section.querySelector('[data-error-for="city"]'), section.dataset.cityError);
        valid = false;
      }

      if (consentInput && !consentInput.checked) {
        setError(section.querySelector('[data-error-for="consent"]'), section.dataset.consentError);
        valid = false;
      }

      if (!valid) {
        const firstError = section.querySelector('.door-compatibility__field-error:not([hidden])');
        if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (!/^https:\/\/formspree\.io\/f\/[a-zA-Z0-9]+\/?$/.test(form.action)) {
        setError(status, section.dataset.endpointError);
        return;
      }

      submit.disabled = true;
      submitText.textContent = section.dataset.submittingLabel;

      try {
        if (consentDateInput) consentDateInput.value = new Date().toISOString();
        const data = new FormData(form);
        data.set('name', name);
        data.set('phone', phone);
        data.set('city', city);
        if (section.dataset.testMode === 'true') {
          data.delete('photo');
        } else {
          data.set('photo', selectedFile, selectedFile.name);
        }

        const response = await fetch(form.action, {
          method: 'POST',
          body: data,
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) throw new Error('Form submission failed');

        summaryImage.src = objectUrl;
        summaryImage.alt = selectedFile.name;
        summaryFile.textContent = selectedFile.name;
        summaryName.textContent = name;
        summaryPhone.textContent = phone;
        summaryCity.textContent = city;
        summary.hidden = true;
        reviewButton.setAttribute('aria-expanded', 'false');
        reviewButton.textContent = reviewButton.dataset.showLabel;
        formContent.hidden = true;
        success.hidden = false;
        success.focus();
      } catch (error) {
        setError(status, section.dataset.sendError);
      } finally {
        submit.disabled = false;
        submitText.textContent = defaultSubmitText;
      }
    });
  };

  const initAll = (root = document) => root.querySelectorAll(selector).forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
